import eventLib from './index';
/* 监听是否展示全局loading */
export function onLoading(callback) {
  eventLib.on('loading', callback);
}
/* 监听登录操作 */
export function onLogin(callback) {
  eventLib.on('login', callback);
}
/* 监听退出操作 */
export function onLogout(callback) {
  eventLib.on('logout', callback);
}
/* 监听路由跳转 */
export function onNavigate(callback) {
  eventLib.on('navigate', callback);
}
